import type { BreakpointsOptions } from '@mui/system/createBreakpoints/createBreakpoints';

export const breakpoints: BreakpointsOptions = {
  values: {
    mobile: 0,
    tablet: 640,
    desktop: 1440,
  },
};
